"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CoreQuadOperation_1 = require("../../tree/core/CoreQuadOperation");
class WebGLCoreQuadOperation extends CoreQuadOperation_1.CoreQuadOperation {
    constructor(context, shader, shaderOwner, renderTextureInfo, scissor, index) {
        super(context, shader, shaderOwner, renderTextureInfo, scissor, index);
        this.extraAttribsDataByteOffset = 0;
    }
    get quadList() {
        return super.quadList;
    }
    getWebGLShader() {
        return this.shader;
    }
    getAttribsDataByteOffset(index) {
        // Where this quad can be found in the attribs buffer.
        return this.quadList.getAttribsDataByteOffset(this.index + index);
    }
    // Returns the relative pixel coordinates in the shader owner to gl position coordinates in the render texture.
    getNormalRenderTextureCoords(x, y) {
        const coords = this.shaderOwner.getRenderTextureCoords(x, y);
        coords[0] /= this.getRenderWidth();
        coords[1] /= this.getRenderHeight();
        coords[0] = coords[0] * 2 - 1;
        coords[1] = 1 - coords[1] * 2;
        return coords;
    }
    getProjection() {
        if (this.renderTextureInfo && this.renderTextureInfo.renderTexture) {
            return this.renderTextureInfo.renderTexture.projection;
        }
        else {
            return this.context.renderExecutor.projection;
        }
    }
}
exports.WebGLCoreQuadOperation = WebGLCoreQuadOperation;
//# sourceMappingURL=WebGLCoreQuadOperation.js.map